import { v4 as uuidv4Raw } from 'uuid';

export function uuidv4(): string {
  return uuidv4Raw();
}
